import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer data-testid="main-footer" className="bg-white text-slate-900 border-t border-slate-200">
            {/* Main Footer */}
            <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
                    {/* Brand Column */}
                    <div>
                        <Link to="/" className="flex items-center gap-2 sm:gap-3 mb-6" data-testid="footer-logo">
                            <img
                                src="https://customer-assets.emergentagent.com/job_network-excellence/artifacts/9goyrt37_Logo%20With%20Shadow.png"
                                alt="Vanfrank Logo"
                                className="h-12 sm:h-16 lg:h-20 w-auto rounded-lg"
                            />
                            <span className="font-bold text-2xl sm:text-3xl lg:text-5xl">Vanfrank</span>
                        </Link>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h4 className="font-semibold text-lg mb-6 text-slate-900">Contact Us</h4>
                        <ul className="space-y-4">
                            <li className="flex items-start gap-3">
                                <MapPin size={18} className="text-blue-500 mt-1 flex-shrink-0" />
                                <span className="text-slate-600 text-sm">
                                    <span className="sm:hidden">
                                        Vanfrank Place | 9, Olaribiro Drive,<br />
                                        Off Allen Avenue, Ikeja<br />
                                        Lagos State, Nigeria.
                                    </span>
                                    <span className="hidden sm:inline">
                                        Vanfrank Place | 9, Olaribiro Drive, Off Allen Avenue, Ikeja<br />
                                        Lagos State, Nigeria.
                                    </span>
                                </span>
                            </li>
                            <li className="flex items-center gap-3">
                                <Phone size={18} className="text-blue-500 flex-shrink-0" />
                                <a
                                    href="tel:+2342012274476"
                                    data-testid="footer-phone"
                                    className="text-slate-600 hover:text-blue-600 transition-colors text-sm"
                                    onClick={() => {
                                        if (window.dataLayer) {
                                            window.dataLayer.push({ event: 'phone_call_click' });
                                        }
                                    }}
                                >
                                    +234 201 227 4476
                                </a>
                            </li>
                            <li className="flex items-center gap-3">
                                <Mail size={18} className="text-blue-500 flex-shrink-0" />
                                <a
                                    href="mailto:lagos@vanfranklimited.com"
                                    data-testid="footer-email"
                                    className="text-slate-600 hover:text-blue-600 transition-colors text-sm"
                                    onClick={() => {
                                        if (window.dataLayer) {
                                            window.dataLayer.push({ event: 'email_click' });
                                        }
                                    }}
                                >
                                    lagos@vanfranklimited.com
                                </a>
                            </li>
                            <li className="flex items-center gap-4">
                                <a
                                    href="https://vanfrank.3cx.ng/LiveChat566122"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="footer-3cx"
                                    className="flex items-center gap-2 text-slate-600 hover:text-blue-600 transition-colors text-sm"
                                    onClick={() => {
                                        if (window.dataLayer) {
                                            window.dataLayer.push({ event: 'whatsapp_click' });
                                        }
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-blue-500">
                                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                                        <path d="M14.05 2a9 9 0 0 1 8 7.94"></path>
                                        <path d="M14.05 6A5 5 0 0 1 18 10"></path>
                                    </svg>
                                    Talk2Direct
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="border-t border-slate-200">
                <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-6">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        <p className="text-slate-500 text-sm">
                            &copy; {currentYear} Vanfrank. All rights reserved.
                        </p>
                        <div className="flex gap-6">
                            <Link to="/privacy" className="text-slate-500 hover:text-blue-600 text-sm transition-colors">
                                Privacy Policy
                            </Link>
                            <Link to="/terms" className="text-slate-500 hover:text-blue-600 text-sm transition-colors">
                                Terms of Service
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};
